import { send, setting } from '../../../assets/images';

export default function getPickupLabels(pickUpOptions, isPDP: boolean = false) {
  // Define label and icon mapping
  const optionMap = {
    'Pick Up At Branch': { text: 'Ambil di Cabang', iconUrl: setting },
    'Install At Branch': { text: 'Pasang di Cabang', iconUrl: setting },
    'Home Delivery': { text: isPDP ? 'Kirim ke Rumah' : 'Kirim', iconUrl: send },
  };

  // Prepare results
  const labels = [];

  // Check for specific combinations
  const hasPickUpAtBranch = pickUpOptions.some((option) => option.code === 'Pick Up At Branch');
  const hasInstallAtBranch = pickUpOptions.some((option) => option.code === 'Install At Branch');
  const hasHomeDelivery = pickUpOptions.some((option) => option.code === 'Home Delivery');

  if (hasPickUpAtBranch && hasHomeDelivery && hasInstallAtBranch) {
    // Combination of Pick Up At Branch and Home Delivery
    if (pickUpOptions.filter((option) => option.code === 'Home Delivery').length > 0) {
      labels.push({ text: isPDP ? 'Kirim ke Rumah' : 'Kirim', iconUrl: send });
    }
    labels.push({ text: 'Pasang/Ambil di Cabang', iconUrl: setting });
  } else if (hasPickUpAtBranch && hasInstallAtBranch) {
    labels.push({ text: 'Pasang/Ambil di Cabang', iconUrl: setting });
  } else {
    // Add individual options
    pickUpOptions.forEach((option) => {
      if (optionMap[option.code]) {
        labels.push(optionMap[option.code]);
      }
    });
  }
  return labels;
}
